/* ============================================================
   WORDS / カート（ドロワー ＋ カートページ）

   ■ 2026-09 の作り直しについて
   以前はドロワーの中身を Section Rendering API
   （GET /cart?sections=main-cart）で描き直し、返ってきたHTMLから
   sections/main-cart.liquid の <template id="wcd-src"> を取り出していた。
   取り出せなかったときに何もせず return していたため、
   「カートに追加しました」の見出しと暗い背景だけが出て
   本文がいつまでも『読み込み中…』のまま止まる不具合が出ていた。

   いまは GET /cart.js（カートJSON）だけでドロワーを組み立てる。
   Liquid でしか分からない情報（クリックポスト対象の product id、
   money の書式、おすすめ商品）は snippets/cart-drawer.liquid が
   JSON で渡してくる。

   ■ 2026-09-04 表示速度の改善について
   カートに追加した直後、GET /cart.js の応答を待ってから明細を組み立てて
   いたため、その1回の通信が遅いとボタンひとつ押せない「読み込み中…」だけの
   画面が長く続いてしまっていた（実測：追加から11秒以上）。
   さらにタイムアウト（3秒）は「読み込み中の表示」を切り替えるだけで、
   /cart.js のリクエスト自体は裏で動き続けていたため、遅い応答が後から届くと
   タイムアウト後の表示を黙って上書きしてしまい、体感の待ち時間が
   タイムアウト設定と一致していなかった。

   直したこと：
   ・/cart/add.js の応答（words:cart:added の detail、商品ページ側が
     そのまま渡してくる）に入っている商品名・数量・価格・画像URLだけで、
     /cart.js を待たずにその場で明細を描く（数量±・削除は誤操作防止のため
     この時点では無効化。行番号がまだ正しく分からないため）。
   ・「カートを見る」「レジへ進む」はドロワーを開いた瞬間から常に表示する。
     何も押せない時間を作らない。
   ・送料無料バーと正確な小計は、確定した cart.total_price が分かるまでは
     絶対に出さない（不確かな金額・送料を見せないため）。
   ・GET /cart.js には AbortController を使い、タイムアウト（2秒）で
     実際にリクエストを打ち切る。届いたら明細・送料無料バー・小計を
     確定値で描き直す。
   ・「こちらもおすすめ」は確定した cart.js の応答が届いたあと、次の
     フレームで追加する（明細の初回描画をブロックしない）。

   ■ 失敗したときの安全網
   /cart.js が2秒で返らない・通信や描画に失敗したときは、
   すでに出している明細（/cart/add.js 由来）はそのまま残す。
   明細すら出せていない場合（イベントの detail が想定と違う等）だけ、
   「カートに追加しました」＋点数の最小表示に切り替える。
   「カートを見る」「レジへ進む」は常に footBox にあるので、
   真っ暗で何も押せないまま放置することはない。エラーは console.error に出す。

   ■ 送料無料のルール（sections/main-cart.liquid と同じ判定を移植）
   ・Shopify の price は「表示金額 × 100」の整数。¥5,500 は 550000。
   ・税込 5,500円以上で送料無料（佐川急便）
   ・カートが「タグ shipping:clickpost の商品1点だけ」ならクリックポストで送料無料
   ・2点以上は佐川急便になるので通常の 5,500円ルールに戻す
   この判定は buildShip() 1か所だけで行い、確定した cart.js の応答にしか
   使わない（/cart/add.js の応答だけでは他の行の有無が分からないため）。

   ■ ドロワーを開くきっかけ
   assets/words-product.js が /cart/add.js 成功時に
   words:cart:added（cancelable:true、detail は /cart/add.js の応答）を
   document に投げる。ここで preventDefault() すると商品ページ側は
   「ドロワーが受け取った」と判断して /cart への遷移をやめる。
   この契約は変えていない。
   ============================================================ */
(function () {
  'use strict';

  var SECTION_ID = 'main-cart';   /* カートページの部分更新にだけ使う */
  var TIMEOUT_MS = 2000;

  function $(sel, root) { return (root || document).querySelector(sel); }
  /* 表示文言（多言語）。snippets/words-t-cart.liquid が window.WORDS_T.cart_js を置く。
     無ければ日本語のまま動く */
  function T(k, ja) { var t = window.WORDS_T && window.WORDS_T.cart_js; return (t && t[k]) || ja; }
  /* 「あと %AMOUNT% で送料無料」のような文言を、%XXX% の部分だけ差し込みノードにして node に追加 */
  function appendTpl(node, tpl, map) {
    var parts = String(tpl).split(/(%[A-Z]+%)/);
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (!p) continue;
      var m = p.match(/^%([A-Z]+)%$/);
      if (m && map[m[1]]) node.appendChild(map[m[1]]);
      else node.appendChild(document.createTextNode(p));
    }
  }
  function $$(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }

  var drawer = document.getElementById('cart-drawer');

  /* ---------- Liquid から渡された値 ---------- */
  function readJSON(node, def) {
    if (!node) return def;
    try { return JSON.parse(node.textContent || ''); }
    catch (err) { console.error('[words-cart] 設定JSONを読めませんでした', err); return def; }
  }
  var CFG  = readJSON(drawer && $('[data-wcd-cfg]', drawer), null) || {};
  var RECO = readJSON(drawer && $('[data-wcd-reco]', drawer), null) || [];
  var CP   = (drawer && drawer.getAttribute('data-wcd-cp')) || ',';
  var FREE_SHIP = typeof CFG.free === 'number' ? CFG.free : 550000;

  function cartUrl()   { return CFG.cart || (window.routes && window.routes.cart_url) || '/cart'; }
  function changeUrl() { return (CFG.change || (window.routes && window.routes.cart_change_url) || '/cart/change') + '.js'; }
  function allUrl()    { return CFG.all || '/collections/all'; }

  /* ---------- 金額 ---------- */
  var MONEY_PRE = '¥';
  var MONEY_SUF = '';
  (function () {
    var z = CFG.zero;
    if (typeof z !== 'string') return;
    var i = z.indexOf('0');
    if (i < 0) return;
    MONEY_PRE = z.slice(0, i);
    MONEY_SUF = z.slice(i + 1).replace(/^[.,]0+/, '');
  })();
  function money(cents) {
    var n = Math.round((Number(cents) || 0) / 100);
    return MONEY_PRE + n.toLocaleString('ja-JP') + MONEY_SUF;
  }
  function countLabel(n) { return T('count', '%COUNT%点').replace('%COUNT%', n); }

  /* ---------- ヘッダーのカート個数バッジ ---------- */
  var lastCount = null;
  (function () {
    var el0 = $('[data-cart-count]');
    if (!el0) return;
    var n = parseInt((el0.textContent || '').replace(/[^0-9]/g, ''), 10);
    if (!isNaN(n)) lastCount = n;
  })();
  function setHeaderCount(n) {
    if (typeof n !== 'number' || isNaN(n)) return;
    lastCount = n;
    $$('[data-cart-count]').forEach(function (el0) { el0.textContent = n; });
  }

  /* ---------- 小さなDOMヘルパー ---------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function txt(s) { return document.createTextNode(s); }
  function clear(node) { while (node && node.firstChild) node.removeChild(node.firstChild); }

  /* ============================================================
     送料無料バー（判定は sections/main-cart.liquid と同じ）
     確定した cart.js の応答にしか呼ばない。
     ============================================================ */
  function shipState(cart) {
    var total = Number(cart.total_price) || 0;
    var count = Number(cart.item_count) || 0;
    var items = cart.items || [];
    var cpAll = count > 0;
    for (var i = 0; i < items.length; i++) {
      if (CP.indexOf(',' + items[i].product_id + ',') < 0) { cpAll = false; break; }
    }
    /* 実際にクリックポストが選べるかは配送設定の合計重量（0〜100g）で決まるので、
       タグだけでなく重量も見る（2026-09-17）。cart.total_weight はグラム */
    var wOk = (typeof cart.total_weight === 'number') ? (cart.total_weight <= 100) : true;
    if (total >= FREE_SHIP) return 'free';
    if (cpAll && wOk && count === 1) return 'free_cp';
    if (cpAll) return 'cp_multi';
    return 'remain';
  }

  function buildShip(cart) {
    var total = Number(cart.total_price) || 0;
    var state = shipState(cart);
    var remain = FREE_SHIP - total;
    if (remain < 0) remain = 0;
    var progress = (state === 'free' || state === 'free_cp')
      ? 100
      : Math.min(100, Math.floor(total * 100 / FREE_SHIP));

    var wrap = el('div', 'wc-ship');
    var line = el('p', 'wc-ship__t');
    var msg  = el('span');
    function hl(t) { return el('span', 'wc-ship__hl', t); }

    if (state === 'free') {
      appendTpl(msg, T('ship_free', '%HL%でお届けします'), { HL: hl(T('ship_free_word', '送料無料')) });
    } else if (state === 'free_cp') {
      appendTpl(msg, T('ship_free_cp', 'クリックポストで%HL%です'), { HL: hl(T('ship_free_word', '送料無料')) });
    } else if (state === 'cp_multi') {
      appendTpl(msg, T('ship_cp_multi', '2点以上は宅配便でのお届けです。あと %AMOUNT% で送料無料'), { AMOUNT: hl(money(remain)) });
    } else {
      appendTpl(msg, T('ship_remain', 'あと %AMOUNT% で送料無料'), { AMOUNT: hl(money(remain)) });
    }
    line.appendChild(msg);
    if (state !== 'free_cp') line.appendChild(el('span', 'wc-ship__goal', money(FREE_SHIP)));
    wrap.appendChild(line);

    var bar = el('div', 'wc-ship__bar');
    var fill = document.createElement('i');
    fill.style.width = progress + '%';
    bar.appendChild(fill);
    wrap.appendChild(bar);
    return wrap;
  }

  /* ============================================================
     明細行・おすすめ
     ============================================================ */
  /* 管理画面のオプション名は Google 連携のため英語（Color / Size）。お客様にはカタカナで見せる（2026-09-24） */
  function optLabel(n) {
    var d = String(n == null ? '' : n).toLowerCase();
    if (d === 'color' || d === 'colour') return T('opt_color', 'カラー');
    if (d === 'size') return T('opt_size', 'サイズ');
    return n;
  }

  function itemOptions(it) {
    var ov = it.options_with_values;
    if (ov && ov.length) {
      var parts = [];
      for (var i = 0; i < ov.length; i++) {
        var v = ov[i] && ov[i].value;
        if (v == null || String(v).toLowerCase() === 'default title') continue;
        parts.push(optLabel(ov[i].name) + T('opt_colon', '：') + v);
      }
      if (parts.length) return parts.join(' ／ ');
      return '';
    }
    if (it.variant_title && it.variant_title !== 'Default Title') return it.variant_title;
    return '';
  }

  /* disabled:true のときは行番号（data-wcart-line）を付けず、数量±・削除も
     押せなくする。/cart/add.js の応答だけでは「カート全体の何行目か」が
     分からないため、確定した cart.js が届くまでの誤操作を防ぐための措置。 */
  function buildItems(cart, disabled) {
    var ul = el('ul', 'wc-list');
    (cart.items || []).forEach(function (it, idx) {
      var name = it.product_title || it.title || '';
      var href = it.url || cartUrl();

      var li = el('li', 'wc-item');
      if (!disabled) {
        li.setAttribute('data-wcart-line', String(idx + 1));
        li.setAttribute('data-wcart-key', it.key || '');
      }

      var ph = el('a', 'wc-item__ph');
      ph.href = href;
      ph.setAttribute('tabindex', '-1');
      ph.setAttribute('aria-hidden', 'true');
      var img = document.createElement('img');
      img.src = it.image || (it.featured_image && it.featured_image.url) || CFG.noimg || '';
      img.alt = '';
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
      img.width = 168; img.height = 210;
      ph.appendChild(img);
      li.appendChild(ph);

      var info = el('div', 'wc-item__info');

      var top = el('div', 'wc-item__top');
      var nm = el('a', 'wc-item__nm', name);
      nm.href = href;
      top.appendChild(nm);
      var del = el('button', 'wc-item__del', T('remove', '削除'));
      del.type = 'button';
      del.setAttribute('data-wcart-remove', '');
      del.setAttribute('aria-label', T('remove_aria', '%TITLE%をカートから削除').replace('%TITLE%', function () { return name; }));
      if (disabled) del.disabled = true;
      top.appendChild(del);
      info.appendChild(top);

      var opt = itemOptions(it);
      if (opt) info.appendChild(el('p', 'wc-item__opt', opt));

      var bot = el('div', 'wc-item__bot');
      var step = el('div', 'wc-step');
      var minus = el('button', null, '−');
      minus.type = 'button';
      minus.setAttribute('data-wcart-qty', '-1');
      minus.setAttribute('aria-label', T('qty_minus_aria', '%TITLE%の数量を減らす').replace('%TITLE%', function () { return name; }));
      if (disabled) minus.disabled = true;
      var input = document.createElement('input');
      input.type = 'text';
      input.setAttribute('inputmode', 'numeric');
      input.name = 'updates[]';
      input.value = it.quantity;
      input.setAttribute('data-wcart-input', '');
      input.setAttribute('aria-label', T('qty_aria', '%TITLE%の数量').replace('%TITLE%', function () { return name; }));
      if (disabled) input.disabled = true;
      var plus = el('button', null, '＋');
      plus.type = 'button';
      plus.setAttribute('data-wcart-qty', '1');
      plus.setAttribute('aria-label', T('qty_plus_aria', '%TITLE%の数量を増やす').replace('%TITLE%', function () { return name; }));
      if (disabled) plus.disabled = true;
      step.appendChild(minus); step.appendChild(input); step.appendChild(plus);
      bot.appendChild(step);
      bot.appendChild(el('span', 'wc-item__pr',
        money(it.final_line_price != null ? it.final_line_price : it.line_price)));
      info.appendChild(bot);

      li.appendChild(info);
      ul.appendChild(li);
    });
    return ul;
  }

  function buildReco(cart) {
    if (!RECO || !RECO.length) return null;
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.product_id] = true; });
    var picks = [];
    for (var i = 0; i < RECO.length && picks.length < 4; i++) {
      if (!inCart[RECO[i].id]) picks.push(RECO[i]);
    }
    if (!picks.length) return null;

    var wrap = el('div', 'wc-reco');
    wrap.appendChild(el('p', 'wc-reco__t', T('reco_title', 'こちらもおすすめ')));
    var row = el('div', 'wc-reco__row');
    picks.forEach(function (p) {
      var a = el('a', 'wc-rc');
      a.href = p.u || allUrl();
      var ph = el('span', 'wc-rc__ph');
      var img = document.createElement('img');
      img.src = p.i || CFG.noimg || '';
      img.alt = p.t || '';
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
      img.width = 150; img.height = 150;
      ph.appendChild(img);
      a.appendChild(ph);
      a.appendChild(el('span', 'wc-rc__nm', p.t || ''));
      a.appendChild(el('span', 'wc-rc__pr', money(p.p)));
      row.appendChild(a);
    });
    wrap.appendChild(row);
    return wrap;
  }

  /* /cart/add.js の応答（words:cart:added の detail）から、明細を組み立てる
     ための配列を取り出す。items 配列（{items:[...]} 形式）を基本とし、
     単品POST時の古い形式（トップレベルにアイテムそのものが入っている形）
     も念のため受ける。取り出せなければ null。 */
  function extractAddedItems(detail) {
    if (!detail) return null;
    if (detail.items && detail.items.length) return detail.items;
    if (detail.id && (detail.title || detail.product_title)) return [detail];
    return null;
  }

  /* ============================================================
     1. カートドロワー
     ============================================================ */
  var Drawer = (function () {
    if (!drawer) return null;

    var sheet   = $('.wcd__sheet', drawer);
    var shipBox = $('[data-wcd-ship]', drawer);
    var bodyBox = $('#wcd-body', drawer);
    var footBox = $('[data-wcd-foot]', drawer);
    var countEl = $('[data-wcd-count]', drawer);
    var titleEl = $('[data-wcd-title]', drawer);
    var subEl   = $('[data-wcd-subtotal]', drawer);

    var open = false;
    var scrollY = 0;
    var lastFocus = null;
    var reqId = 0;
    var optimisticShown = false;   /* /cart/add.js の応答だけで明細を出せているか */
    var activeController = null;   /* 進行中の /cart.js リクエストを閉じる時に打ち切るため */

    function lock() {
      scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.top = (-scrollY) + 'px';
      document.body.classList.add('wcd-open');
    }
    function unlock() {
      document.body.classList.remove('wcd-open');
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
    }

    function openChrome() {
      if (open) return;
      open = true;
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      lock();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { drawer.classList.add('is-in'); });
      });
      try {
        if (sheet) { sheet.setAttribute('tabindex', '-1'); sheet.focus({ preventScroll: true }); }
      } catch (err) { /* focus は失敗しても描画を止めない */ }
    }

    function hide() {
      if (!open) return;
      open = false;
      reqId++;                       /* 進行中の描画を無効化 */
      if (activeController) { try { activeController.abort(); } catch (err) { /* noop */ } activeController = null; }
      drawer.classList.remove('is-in');
      drawer.setAttribute('aria-hidden', 'true');
      unlock();
      window.setTimeout(function () {
        if (!open) drawer.classList.remove('is-open');
      }, 320);
      if (lastFocus && lastFocus.focus) {
        try { lastFocus.focus({ preventScroll: true }); } catch (err) { /* noop */ }
      }
    }

    /* カートJSON（確定値）→ ドロワーの各パーツ。送料無料バー・正確な小計は
       ここでしか出さない。 */
    function render(cart) {
      var my = reqId;
      var count = Number(cart.item_count) || 0;
      var isEmpty = count === 0;

      if (countEl) countEl.textContent = isEmpty ? '' : countLabel(count);
      if (subEl) subEl.textContent = money(cart.total_price);
      setHeaderCount(count);

      if (shipBox) {
        clear(shipBox);
        if (!isEmpty) shipBox.appendChild(buildShip(cart));
        shipBox.hidden = isEmpty;
      }

      if (bodyBox) {
        clear(bodyBox);
        if (isEmpty) {
          var em = el('div', 'wcd__empty');
          em.appendChild(el('p', null, T('empty', 'カートに商品がありません。')));
          var a = el('a', 'btn-ink', T('view_all', 'すべての商品を見る'));
          a.href = allUrl();
          em.appendChild(a);
          bodyBox.appendChild(em);
        } else {
          bodyBox.appendChild(buildItems(cart));
          /* 「こちらもおすすめ」は明細の初回描画をブロックしないよう次のフレームで追加する */
          requestAnimationFrame(function () {
            if (my !== reqId || !bodyBox) return;
            var reco = buildReco(cart);
            if (reco) bodyBox.appendChild(reco);
          });
        }
        bodyBox.setAttribute('aria-busy', 'false');
      }

      if (footBox) footBox.hidden = isEmpty;
    }

    /* 明細すら出せていないときだけの最小表示。
       「カートを見る」「レジへ進む」は footBox に常にあるので、ここでは
       重複したボタンは作らない。 */
    function fallback() {
      if (shipBox) { clear(shipBox); shipBox.hidden = true; }
      if (subEl) subEl.textContent = '';
      if (footBox) footBox.hidden = false;
      var known = typeof lastCount === 'number' && lastCount > 0;
      if (countEl) countEl.textContent = known ? countLabel(lastCount) : '';
      if (!bodyBox) return;

      clear(bodyBox);
      var box = el('div', 'wcd__fb');
      box.appendChild(el('p', 'wcd__fb-t',
        known ? T('fb_count', 'カートの中身は %COUNT%点 です').replace('%COUNT%', lastCount) : T('fb_failed', 'カートの内容を読み込めませんでした')));
      box.appendChild(el('p', 'wcd__fb-n', T('fb_note', '下のボタンからカートをご確認ください。')));
      bodyBox.appendChild(box);
      bodyBox.setAttribute('aria-busy', 'false');
    }

    /* /cart/add.js の応答だけで明細を仮描画する（数量±・削除は無効化）。
       送料無料バー・小計は確定するまで出さない。 */
    function renderOptimistic(items) {
      if (!bodyBox) return false;
      var built;
      try { built = buildItems({ items: items }, true); }
      catch (err) { console.error('[words-cart] 追加直後の明細を組み立てられませんでした', err); return false; }

      clear(bodyBox);
      bodyBox.appendChild(built);
      bodyBox.setAttribute('aria-busy', 'true');

      if (shipBox) { clear(shipBox); shipBox.hidden = true; }
      if (subEl) subEl.textContent = '';
      if (countEl) countEl.textContent = (typeof lastCount === 'number' && lastCount > 0) ? countLabel(lastCount) : '';
      if (footBox) footBox.hidden = false;
      return true;
    }

    function draw(cart, my) {
      if (my !== reqId) return;
      try {
        render(cart);
        optimisticShown = false;
      } catch (err) {
        console.error('[words-cart] ドロワーの描画に失敗しました', err);
        if (!optimisticShown) {
          fallback();
        } else if (bodyBox) {
          bodyBox.setAttribute('aria-busy', 'false');
        }
      }
    }

    /* /cart.js が届かなかった／失敗したときの処理。
       すでに /cart/add.js 由来の明細（renderOptimistic）が出ていれば
       それをそのまま残す（送料無料バー・小計は空のまま）。
       何も出せていなければ fallback() の最小表示にする。 */
    function onCartUnavailable(my) {
      if (my !== reqId) return;
      if (bodyBox) bodyBox.setAttribute('aria-busy', 'false');
      if (!optimisticShown) fallback();
    }

    /* GET /cart.js を1回だけ投げる。TIMEOUT_MS で本当に打ち切る
      （AbortController）。届いたら draw() で確定表示に描き直す。 */
    function fetchCart(my) {
      if (footBox) footBox.hidden = false; /* 読み込み中でも必ずボタンを出す */

      var controller = (typeof AbortController === 'function') ? new AbortController() : null;
      activeController = controller;
      var timedOut = false;

      var timer = window.setTimeout(function () {
        timedOut = true;
        if (controller) { try { controller.abort(); } catch (err) { /* noop */ } }
        if (my !== reqId) return;
        console.error('[words-cart] /cart.js が ' + TIMEOUT_MS + 'ms 以内に返りませんでした');
        onCartUnavailable(my);
      }, TIMEOUT_MS);

      fetch(cartUrl() + '.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store',
        signal: controller ? controller.signal : undefined
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (cart) {
          window.clearTimeout(timer);
          if (activeController === controller) activeController = null;
          if (timedOut || my !== reqId) return;
          if (!cart || typeof cart.item_count === 'undefined') throw new Error('カートJSONの形式が想定と違います');
          draw(cart, my);
        })
        .catch(function (err) {
          window.clearTimeout(timer);
          if (activeController === controller) activeController = null;
          if (timedOut || my !== reqId) return;
          console.error('[words-cart] カート情報を取得できませんでした', err);
          onCartUnavailable(my);
        });
    }

    /* カートに追加した直後。/cart/add.js の応答（detail）だけで
       明細を即座に描き、裏で /cart.js を確定取得しに行く。 */
    function showAdded(detail) {
      if (titleEl) titleEl.textContent = T('added', 'カートに追加しました');
      openChrome();

      var my = ++reqId;
      optimisticShown = false;
      if (footBox) footBox.hidden = false; /* 読み込み中でも必ずボタンを出す */

      var items = extractAddedItems(detail);
      if (items && items.length && renderOptimistic(items)) {
        optimisticShown = true;
      } else if (bodyBox) {
        clear(bodyBox);
        bodyBox.appendChild(el('p', 'wcd__loading', T('loading', '読み込み中…')));
        bodyBox.setAttribute('aria-busy', 'true');
        if (countEl) countEl.textContent = (typeof lastCount === 'number' && lastCount > 0) ? countLabel(lastCount) : '';
      }

      fetchCart(my);
    }

    /* カートアイコンなどから開く一般的な入口。/cart/add.js の応答が無いので
       最初は「読み込み中…」のまま、裏で /cart.js を確定取得する。 */
    function show(title) {
      if (titleEl) titleEl.textContent = title || T('cart', 'カート');
      if (open) { refresh(); return; }
      openChrome();
      refresh();
    }

    function refresh() {
      var my = ++reqId;
      optimisticShown = false;
      if (bodyBox) {
        clear(bodyBox);
        bodyBox.appendChild(el('p', 'wcd__loading', T('loading', '読み込み中…')));
        bodyBox.setAttribute('aria-busy', 'true');
      }
      fetchCart(my);
    }

    /* 閉じる操作：×／オーバーレイ／Esc */
    drawer.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-wcd-close]')) {
        e.preventDefault();
        hide();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (open && (e.key === 'Escape' || e.key === 'Esc')) hide();
    });

    return {
      show: show,
      showAdded: showAdded,
      hide: hide,
      render: function (cart) { draw(cart, reqId); },
      fallback: fallback,
      isOpen: function () { return open; }
    };
  })();

  /* 商品ページから「ドロワーはある？」と聞かれるための目印 */
  if (Drawer) {
    window.WordsCart = {
      open: function () { Drawer.show(T('cart', 'カート')); },
      close: function () { Drawer.hide(); }
    };
  }

  /* カート追加 → ドロワーを開く。
     preventDefault() を返さないと商品ページ側が /cart へ遷移する。
     detail（/cart/add.js の応答）はそのまま showAdded() に渡し、
     /cart.js を待たずに明細を描く。 */
  document.addEventListener('words:cart:added', function (e) {
    if (!Drawer) return;
    if (e.cancelable) e.preventDefault();

    /* 通信が落ちたときの安全網用に、点数の見込みを進めておく */
    var added = 0;
    var d = e.detail;
    if (d) {
      if (d.items && d.items.length) {
        for (var i = 0; i < d.items.length; i++) added += (Number(d.items[i].quantity) || 0);
      } else if (d.quantity) {
        added = Number(d.quantity) || 0;
      }
    }
    if (added > 0) lastCount = (typeof lastCount === 'number' ? lastCount : 0) + added;

    Drawer.showAdded(d);
  });

  /* ============================================================
     2. 数量変更・削除
        ドロワー : /cart/change.js の戻り値（カートJSON）で描き直す
        カートページ : Section Rendering API で #wcart-app を差し替える
     ============================================================ */
  var pageApp = document.getElementById('wcart-app');

  function swapPage(html) {
    var cur = document.getElementById('wcart-app');
    if (!cur) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.getElementById('wcart-app');
    if (!next) return false;
    cur.innerHTML = next.innerHTML;
    return true;
  }

  function change(line, qty, row, inDrawer) {
    if (row) row.classList.add('is-busy');

    var payload = { line: line, quantity: qty };
    if (!inDrawer) {
      payload.sections = SECTION_ID;
      payload.sections_url = cartUrl();
    }

    fetch(changeUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || data.status) throw new Error('cart/change.js が失敗しました');
        setHeaderCount(data.item_count);

        if (inDrawer) {
          if (Drawer) Drawer.render(data);
          return;
        }
        var html = data.sections && data.sections[SECTION_ID];
        if (!html || !swapPage(html)) {
          console.error('[words-cart] カートページの再描画に失敗したので読み込み直します');
          window.location.reload();
        }
      })
      .catch(function (err) {
        console.error('[words-cart] 数量の変更に失敗しました', err);
        if (inDrawer && Drawer) { Drawer.fallback(); return; }
        window.location.reload();
      })
      .then(function () { if (row) row.classList.remove('is-busy'); });
  }

  /* どちら側のカートを触ったのか */
  function context(target) {
    if (!target || !target.closest) return null;
    if (drawer && drawer.contains(target)) return 'drawer';
    var app = document.getElementById('wcart-app');
    if (app && app.contains(target)) return 'page';
    return null;
  }

  document.addEventListener('click', function (e) {
    var ctx = context(e.target);
    if (!ctx) return;

    var row = e.target.closest('[data-wcart-line]');
    if (!row) return;
    var line = parseInt(row.getAttribute('data-wcart-line'), 10);
    if (isNaN(line)) return;

    var step = e.target.closest('[data-wcart-qty]');
    if (step) {
      e.preventDefault();
      var input = row.querySelector('[data-wcart-input]');
      var q = (parseInt(input && input.value, 10) || 1) + parseInt(step.getAttribute('data-wcart-qty'), 10);
      if (q < 0) q = 0;
      change(line, q, row, ctx === 'drawer');
      return;
    }

    if (e.target.closest('[data-wcart-remove]')) {
      e.preventDefault();
      change(line, 0, row, ctx === 'drawer');
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-wcart-input]')) return;
    var ctx = context(e.target);
    if (!ctx) return;
    var row = e.target.closest('[data-wcart-line]');
    if (!row) return;
    var q = parseInt(e.target.value, 10);
    if (isNaN(q) || q < 0) q = 1;
    change(parseInt(row.getAttribute('data-wcart-line'), 10), q, row, ctx === 'drawer');
  });

  /* 数量入力で Enter を押してもフォーム送信させない */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (!e.target.matches || !e.target.matches('[data-wcart-input]')) return;
    e.preventDefault();
    e.target.blur();
  });

  /* カートページを開いた時点でヘッダーの個数を合わせておく */
  if (pageApp) {
    fetch(cartUrl() + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c) setHeaderCount(c.item_count); })
      .catch(function (err) { console.error('[words-cart] カート個数の同期に失敗しました', err); });
  }
})();

/* ============================================================
   ギフト包装（無料）のチェック
   ・カートページ（sections/main-cart.liquid）とカートドロワー
     （snippets/cart-drawer.liquid）の両方に同じチェックボックスがある。
   ・どちらも <form action="/cart" method="post"> の中にあるので、
     「レジへ進む」を押した時点でカート属性として送信される（JSが無くても動く）。
   ・ここでは、チェックした時点で /cart/update.js にも保存して、
     ページを移動しても状態が残るようにする。同じページに2つある場合は
     もう一方のチェックも合わせる。
   ・通信に失敗してもフォーム送信側で送られるので、画面は元に戻さない。
   ============================================================ */
(function () {
  var KEY = 'ギフト包装';
  var VAL = '希望する';

  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box || !box.matches || !box.matches('[data-cart-gift]')) return;

    var on = box.checked;

    /* 同じページにあるもう一方のチェックも合わせる */
    var all = document.querySelectorAll('[data-cart-gift]');
    for (var i = 0; i < all.length; i++) { all[i].checked = on; }

    var body = { attributes: {} };
    body.attributes[KEY] = on ? VAL : '';

    var url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '/update.js';

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).catch(function (err) {
      console.error('[words-cart] ギフト包装の保存に失敗しました', err);
    });
  });
})();

/* ============================================================
   お届け希望日・時間帯（2026-09-20 追加）
   ・カートページ（sections/main-cart.liquid）にだけ置いている。
     カートドロワーには無い（備考と同じ扱い）。
   ・ギフト包装と同じカート属性。<form> の中にあるので、JSが途中で
     こけても「レジへ進む」を押せば選択済みの値は送信される。
   ・設定はショップのメタフィールドから来る（main-cart.liquid の
     data-dd-config を参照）。テーマを上げ直しても消えないようにするため。
   ・最短指定日 ＝ 今日から lead 営業日後（＝最遅の発送日）＋ plus 日。
     営業日＝土日・祝日・臨時休業日を除く日。
     お届け日のほうは暦日（佐川急便は土日祝も配達するため）。
   ============================================================ */
(function () {
  var root = document.querySelector('[data-cart-dd]');
  if (!root) return;

  var cfgEl   = root.querySelector('[data-dd-config]');
  var dateSel = root.querySelector('[data-dd-date]');
  var slotSel = root.querySelector('[data-dd-slot]');
  if (!cfgEl || !dateSel || !slotSel) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var KEY_D = 'お届け希望日';
  var KEY_S = 'お届け時間帯';
  var WD = ['日', '月', '火', '水', '木', '金', '土'];
  /* 画面に見せる日付（多言語）。送信する値（label）は日本語の形式のまま */
  function T(k, ja) { var t = window.WORDS_T && window.WORDS_T.cart_js; return (t && t[k]) || ja; }
  var WD_SHOW = String(T('weekdays', '日,月,火,水,木,金,土')).split(',');
  if (WD_SHOW.length !== 7) WD_SHOW = WD;
  var DATE_FMT = T('date_fmt', '%Y年%M月%D日（%W）');
  function showLabel(d) {
    return DATE_FMT.replace('%Y', d.getFullYear()).replace('%M', d.getMonth() + 1)
      .replace('%D', d.getDate()).replace('%W', WD_SHOW[d.getDay()]);
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function ymd(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function label(d) {
    return d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日（' + WD[d.getDay()] + '）';
  }

  /* 「2026-08-13〜2026-08-16 お盆休み」「2026-11-03 棚卸し」を日付の集合にする。
     行頭の日付だけを見て、うしろの説明文は無視する。read できない行は黙って飛ばす。 */
  function parseDays(text) {
    var set = {};
    if (!text) return set;
    var lines = String(text).split(/\r?\n/);
    for (var i = 0; i < lines.length; i++) {
      var head = lines[i].trim().split(/[\s　]+/)[0];
      if (!head) continue;
      var m = head.match(/^(\d{4}-\d{2}-\d{2})(?:[〜~～](\d{4}-\d{2}-\d{2}))?$/);
      if (!m) continue;
      var a = new Date(m[1] + 'T00:00:00');
      var b = m[2] ? new Date(m[2] + 'T00:00:00') : new Date(m[1] + 'T00:00:00');
      if (isNaN(a.getTime()) || isNaN(b.getTime()) || b < a) continue;
      var d = new Date(a), guard = 0;
      while (d <= b && guard < 400) { set[ymd(d)] = true; d.setDate(d.getDate() + 1); guard++; }
    }
    return set;
  }

  var closed = parseDays(cfg.closed);
  var holi   = parseDays(cfg.holidays);

  function isBiz(d) {
    var w = d.getDay();
    if (w === 0 || w === 6) return false;
    var k = ymd(d);
    return !holi[k] && !closed[k];
  }

  var lead  = Math.max(0, parseInt(cfg.lead, 10)  || 0);
  var plus  = Math.max(0, parseInt(cfg.plus, 10)  || 0);
  var range = Math.min(60, Math.max(1, parseInt(cfg.range, 10) || 14));

  /* 最遅の発送日：明日から数えて lead 営業日目 */
  var ship = new Date(); ship.setHours(0, 0, 0, 0);
  var n = 0, guard = 0;
  while (n < lead && guard < 400) {
    ship.setDate(ship.getDate() + 1); guard++;
    if (isBiz(ship)) n++;
  }

  /* 最短指定日：最遅の発送日 ＋ plus 日（暦日） */
  var first = new Date(ship);
  first.setDate(first.getDate() + plus);

  var frag = document.createDocumentFragment();
  var cur = new Date(first);
  for (var j = 0; j < range; j++) {
    var o = document.createElement('option');
    o.value = label(cur);
    o.textContent = showLabel(cur);
    frag.appendChild(o);
    cur.setDate(cur.getDate() + 1);
  }
  dateSel.appendChild(frag);

  /* 保存済みの選択を戻す。期限切れで選択肢から外れていたら、黙って消す。 */
  var saved = cfg.date || '';
  var stale = false;
  if (saved) {
    var hit = false;
    for (var k = 0; k < dateSel.options.length; k++) {
      if (dateSel.options[k].value === saved) { hit = true; break; }
    }
    if (hit) { dateSel.value = saved; } else { stale = true; }
  }
  if (dateSel.value && cfg.slot) { slotSel.value = cfg.slot; }
  syncSlot();
  root.removeAttribute('hidden');
  if (stale) save();

  /* 日付が「指定なし」のとき、時間帯だけ選べても意味がないので閉じる */
  function syncSlot() {
    var on = !!dateSel.value;
    slotSel.disabled = !on;
    if (!on) slotSel.value = '';
  }

  function save() {
    var body = { attributes: {} };
    body.attributes[KEY_D] = dateSel.value || '';
    body.attributes[KEY_S] = slotSel.value || '';
    var url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '/update.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).catch(function (err) {
      console.error('[words-cart] お届け希望日時の保存に失敗しました', err);
    });
  }

  dateSel.addEventListener('change', function () { syncSlot(); save(); });
  slotSel.addEventListener('change', save);
})();
